
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as geBGux9NKqDQ9Fjd9RykXYRmYfbj3UWwhbYyVkQmJjPEMeta } from "/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexmTaSm_45IDbA_FTusdwrWHBGH6IpwTgzbfzceyypdtuUUMeta } from "/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchS8CntvEA469lGIVVcChzkebsyu3j_45EjQK11aEvxvbV0Meta } from "/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexoDnVTCRg_kQFb2pgyGInikfYVrI7mOFQqY9AfTwdmTQMeta } from "/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93E_e9aagIJjwghX2L7YZtwG8mCtBq1eqWbUr_45SSVFUXgMeta } from "/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexDrOQOOVbn4OTKDLR2kIDU1itzC1f_45Iy1tKH1CoP1fNsMeta } from "/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93st0VbwZRCyfwryuC9r739eSp3Hrlrju_4584xeXPCjanwMeta } from "/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexnEV4J_45hgA5yOb7g531PF5NsI7el1a_1qFgMl0EyUhEoMeta } from "/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93oQ1nwGNfUvOEWJzvd5yy3fzOVw_45j6p9lT_jRknLkXBYMeta } from "/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexmMDcHD9d12r3wozP_45ZMsGQRr30Ua9ly85wwTWvowoYsMeta } from "/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexJcbHib_45G_45jSGABAMYrJ22AC17bH_Hrbmiu5TQPmXuB4Meta } from "/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexDrOQOOVbn4OTKDLR2kIDU1itzC1f_45Iy1tKH1CoP1fNsMeta || {},
    component: () => import("/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexnEV4J_45hgA5yOb7g531PF5NsI7el1a_1qFgMl0EyUhEoMeta || {},
    component: () => import("/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexmMDcHD9d12r3wozP_45ZMsGQRr30Ua9ly85wwTWvowoYsMeta || {},
    component: () => import("/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexJcbHib_45G_45jSGABAMYrJ22AC17bH_Hrbmiu5TQPmXuB4Meta || {},
    component: () => import("/codebuild/output/src537698917/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]